import { render, staticRenderFns } from "./ListMenu.vue?vue&type=template&id=1061aa93&scoped=true"
import script from "./ListMenu.vue?vue&type=script&lang=ts"
export * from "./ListMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1061aa93",
  null
  
)

export default component.exports